<script lang="ts">
  import { type Snippet } from "svelte"
  import MainNav from "./MainNav.svelte"
  import Footer from "./Footer.svelte"
  import Flash from "./Flash.svelte"

  import { appStore } from "$app/store.svelte"

  let props = $props()

  let {
    current_user,
    plan,
    plan_users,
    app_banner,
    onboarding,
    flash,
    children,
    params
  }: {
    current_user: UserType
    plan: PlanType
    plan_users: UserType[]
    app_banner: any
    plans: PlanType[]
    onboarding: any
    meeting: MeetingType
    flash: any
    children: Snippet
    params: any
  } = props

  appStore.current_user = current_user
  appStore.users = Object.values(plan_users).map((k, v) => k)
  appStore.plan = plan
  appStore.onboarding = onboarding
  appStore.params = params
  appStore.onboarding = onboarding || {}
</script>

<svelte:head>
  <script
    async
    src="https://www.googletagmanager.com/gtag/js?id=G-RXGMN2WVWL"
  ></script>
  <script>
    window.dataLayer = window.dataLayer || []
    function gtag() {
      dataLayer.push(arguments)
    }
    gtag("js", new Date())

    gtag("config", "G-RXGMN2WVWL")
  </script>
</svelte:head>

<div id="main-layout">
  <MainNav
    plan={appStore.plan}
    plans={appStore.plans}
    current_user={appStore.current_user}
  />

  <main class="bg-lwp-pale-grey">
    <Flash flash={appStore.flash} />

    {@render children()}
  </main>

  <Footer />
</div>
